export function canShowTickingClock(user = window.gon.currentUser) {
  if (!user) return false
  if (!timeSinceTrialStarted(user)) return false
  if (!["user", "trial"].includes(user.role)) return false
  // within first 24h after registration
  return timeSinceTrialStarted(user) < 24 * 60 * 60 * 1000
}

export function trialTimeLeft(user = window.gon.currentUser) {
  if (!timeSinceTrialStarted(user)) return false
  return 65 * 60 * 1000 - timeSinceTrialStarted(user)
}

function timeSinceTrialStarted(user = window.gon.currentUser) {
  return Date.now() - user.trialStartedAt * 1000
}
